import { memo } from 'react'

type colorType = 'default' | 'primary'

export const PinComponent = ({ color }: { color: colorType }) => {
  let className: string
  switch (color) {
    case 'primary':
      className = 'stroke-primary-500'
      break
    default:
      className = 'stroke-white'
  }

  return (
    <svg
      width="19"
      height="25"
      viewBox="0 0 19 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0594 10.3573L12.9196 9.8V2.46667L14.4095 1H3.97989L5.46984 2.46667V9.8L4.33003 10.3573C2.2888 11.362 1 13.4153 1 15.6667H17.3894C17.3894 13.4227 16.1006 11.362 14.0594 10.3573Z"
        className={className}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.1947 16.6665V23.9998"
        className={className}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Pin = memo(PinComponent)
